export const PLAN_INFO = [
  { key: 1, label: 'Plan Network', value: 'planName' },
  { key: 2, label: 'Plan Number', value: 'planId' },
  { key: 3, label: 'Employer', value: 'employer' },
  { key: 4, label: 'Start Date', value: 'startDate' },
  { key: 5, label: 'End Date', value: 'endDate' }
] as const;

export const ADDITIONAL_RESOURCES = [
  {
    key: 1,
    title: 'Medical Cost Estimator',
    body: "Plan for what's ahead by getting cost estimates for hundreds of procedures",
    redirectTo: 'EstimateCost'
  },
  {
    key: 2,
    title: 'Contact SelectHealth',
    body: 'www.selecthealth.org',
    redirectTo: 'https://selecthealth.org/about-us/contact-us',
    type: 'web',
    contact: '(800)538-5038'
  }
];
